import { useQuery } from 'react-query'
import { useNavigate } from 'react-router-dom'
import Typography from '@mui/material/Typography'
import AdxTableBottomCTA from 'components/reusable/table/AdxTableBottomCTA'
import UnsubmittedReportsList from './lists/UnsubmittedReportsList'
import { getQueryReports } from 'services/api/modules/claim/report'
import { ReportIconConstructor } from 'module/claim/pages/report/functions'
import ClaimLoadingState from './ClaimLoadingState'
import AdxEmptyStateV2 from 'components/reusable/emptyState/AdxEmptyStateV2'
import { Box, Icon } from '@mui/material'

const UnsubmittedReportPanel = () => {
  const ViewAllUnsubmittedButton = () => {
    const navigate = useNavigate()
    return (
      <Typography
        variant="body1"
        color="alternate.main"
        sx={{ textDecoration: 'underline', cursor: 'pointer' }}
        onClick={() =>
          navigate(`../claim/reports`, {
            state: { fromDashboard: true, initialTabsValue: 0 },
          })
        }
      >
        View All
      </Typography>
    )
  }

  const { data: unsubmittedReportData, isLoading } = useQuery(
    'unsubmittedReportsData',
    async () => {
      const { data } = await getQueryReports({ status: 'draft' })
      return data?.reports
    }
  )

  if (isLoading) {
    return <ClaimLoadingState />
  }

  return (
    <AdxTableBottomCTA
      bottomCTA={<ViewAllUnsubmittedButton />}
      emptyStateComponent={<AdxEmptyStateV2 icon={<Icon>article</Icon>} title="No draft reports" />}
    >
      {unsubmittedReportData?.length > 0 &&
        unsubmittedReportData?.slice(0, 7)?.map((list, index) => {
          return (
            <UnsubmittedReportsList
              key={index}
              reportID={list.id}
              reportType={list.claim_report_type}
              reportName={list.title}
              muiIcon={ReportIconConstructor(list.claim_report_type)}
              startDate={list.start_date}
              endDate={list.end_date}
              totalAmount={list.amount_total}
              status="DRAFT"
            />
          )
        })}
    </AdxTableBottomCTA>
  )
}

export default UnsubmittedReportPanel
